import request from '@/plugins/axios'
import systemConfig from '@/plugins/requireConfig/systemConfig.js'


/**
 * 添加机构
 */

export function addOrganization(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/cultivateInstitutionInfo/gl/v1.0.0/add`,
        method: 'post',
        data
    })
}

/**
 * 编辑机构
 */
export function editOrganization(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/cultivateInstitutionInfo/gl/v1.0.0/update`,
        method: 'post',
        data
    })
}

/**
 * 删除机构
 */
export function deleteOrganization(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/cultivateInstitutionInfo/gl/v1.0.0/delete`,
        method: 'post',
        data
    })
}

/**
 * 获取机构列表
 */
export function getOrganizationList(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/cultivateInstitutionInfo/gl/v1.0.0/page`,
        method: 'post',
        data
    })
}


/**
 * 获取机构列表
 */
export function getOrganizationLists(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/cultivateProjectInfo/gl/v1.0.0/page`,
        method: 'post',
        data
    })
}

/**
 * 培训项目-新增（与机构 addOrganization 区分）
 */
export function addOrganizations(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/cultivateProjectInfo/gl/v1.0.0/add`,
        method: 'post',
        data
    })
}

/**
 * 培训项目-编辑
 */
export function editOrganizations(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/cultivateProjectInfo/gl/v1.0.0/update`,
        method: 'post',
        data
    })
}

/**
 * 培训项目-删除（与机构 deleteOrganization 区分）
 */
export function deleteOrganizations(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/cultivateProjectInfo/gl/v1.0.0/delete`,
        method: 'post',
        data
    })
}

/**
 * 培训项目详情
 */
export function getTrainingProjectDetail(id) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/cultivateProjectInfo/gl/v1.0.0/detail`,
        method: 'post',
        data: {
            id: id
        }
    })
}

/**
 * 获取机构详情
 */

export function getOrganizationDetail(id) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/cultivateInstitutionInfo/gl/v1.0.0/detail`,
        method: 'post',
        data: {
            id: id
        }
    })
}

/**
 * 下载模板
 */
export function downloadTemplate(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/cultivateInstitutionInfo/gl/v1.0.0/excelTemplateGain`,
        method: 'post',
        data,
        responseType: 'blob'
    })
}

/**
 * 导入机构
 */
export function importOrganization(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/cultivateInstitutionInfo/gl/v1.0.0/institutionImport`,
        method: 'post',
        data
    })
}


/**
 * 培训班列表
 */
export function getTrainingClassList(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/trainingClasses/gl/v1.0.0/getTrainingClassesListPage`,
        method: 'post',
        data
    })
}

/**
 * 
 * @param {培训机构列表数据} data 
 * @returns 
 */
export function getTrainingInstitutionList(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/trainingInstitutions/gl/v1.0.0/getTrainingInstitutionsListPage`,
        method: 'post',
        data
    })
}

/**
 * 
 * @param {培训机构详情}data
 * @returns
 */
export function getTrainingInstitutionDetail(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/trainingInstitutions/gl/v1.0.0/getTrainingInstitutionsDetail`,
        method: 'post',
        data
    })
}

/***
 * 
 * @param {培训机构管理团队}data
 * @returns
 */
export function getTrainingInstitutionTeam(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/trainingInstitutions/gl/v1.0.0/getTrainingInstitutionManagementTeam `,
        method: 'post',
        data
    })
}

/**
 * 
 * @param {培训机构教学点列表}data
 * @returns
 */
export function getTrainingInstitutionTeachingPointList(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/trainingInstitutions/gl/v1.0.0/getTrainingInstitutionTeachingPoints`,
        method: 'post',
        data
    })
}

/***
 * 
 * @param {培训机构培训项目列表}data
 * @returns
 */
export function getTrainingInstitutionTrainingProgramList(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/trainingInstitutions/gl/v1.0.0/getTrainingInstitutionProjects`,
        method: 'post',
        data
    })
}

/**
 * 
 * @param {培训类型}data
 * @returns
 */
export function getTrainingType(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/trainingInstitutions/gl/v1.0.0/getTrainingInstitutionClassesSubsidyType`,
        method: 'post',
        data
    })
}

/**
 * 
 * @param {培训等级}data
 */
export function getTrainingLevel(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/trainingInstitutions/gl/v1.0.0/getTrainingInstitutionClassesProjectLevel`,
        method: 'post',
        data
    })
}


/**
 * @param {培训班级列表}data
 * @returns
 */
export function getTrainingClassListInfo(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/trainingInstitutions/gl/v1.0.0/getTrainingInstitutionClasses`,
        method: 'post',
        data
    })
}

/**
 * 
 * @param {培训班级详情}data
 * @returns
 */
export function getTrainingClassDetail(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/trainingClasses/gl/v1.0.0/getTrainingClassesDetail`,
        method: 'post',
        data
    })
}

/**
 * 
 * @param {培训班级授课计划}data
 * @returns
 */
export function getTrainingClassTeachingPlan(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/trainingClasses/gl/v1.0.0/getTrainingClassTeachingPlan`,
        method: 'post',
        data
    })
}


/**
 * 
 * @param {学员类型}data
 */
export function getTrainingClassStudentType(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/trainingClasses/gl/v1.0.0/getTrainingClassStudentsStudentType`,
        method: 'post',
        data
    })
}

/**
 * 
 * @param {补贴类型}data
 */
export function getTrainingClassStudentSubsidyType(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/trainingClasses/gl/v1.0.0/getTrainingClassStudentsSubsidyType`,
        method: 'post',
        data
    })
}

/**
 * 
 * @param {培训班级学员列表}data
 * @returns
 */
export function getTrainingClassStudentList(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/trainingClasses/gl/v1.0.0/getTrainingClassStudents`,
        method: 'post',
        data
    })
}

/**
 * 
 * @param {培训班级教师列表}data
 * @returns
 */
export function getTrainingClassTeacherList(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/trainingClasses/gl/v1.0.0/getTrainingClassContractTeachers`,
        method: 'post',
        data
    })
}

/**
 * 培训班级考勤（trainingClasses 服务）
 * @param {培训班级考勤记录} data
 * @returns
 */
export function getTrainingClassAttendanceRecord(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/trainingClasses/gl/v1.0.0/getTrainingClassAttendance`,
        method: 'post',
        data
    })
}

/**
 * 培训班级考勤（活动 cultivateActivityInfo，与 trainingClasses 接口并存）
 */
export function getTrainingClassAttendanceByActivity(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/cultivateActivityInfo/gl/v1.0.0/getTrainingClassAttendance`,
        method: 'post',
        data
    })
}

/**
 * 
 * @param {关联机构}data
 * @returns 
 */
export function getTrainingInstitutionRelated(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/cultivateInstitutionInfo/gl/v1.0.0/list`,
        method: 'post',
        data
    })
}


/**
 * 
 * @param {关联培训项目}data
 * @returns
 */
export function getTrainingProjectRelated(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/cultivateProjectInfo/gl/v1.0.0/list`,
        method: 'post',
        data
    })
}

/**
 * 
 * @param {活动新增}data
 * @returns
 */
export function getTrainingClassSignupInfo(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/cultivateActivityInfo/gl/v1.0.0/add`,
        method: 'post',
        data
    })
}

/**
 * 活动编辑（字段与新增一致，需带 id）
 * @param {Object} data
 * @returns
 */
export function updateTrainingClassSignupInfo(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/cultivateActivityInfo/gl/v1.0.0/update`,
        method: 'post',
        data
    })
}

/**
 * 
 * @param{活动列表}data
 * @returns
 */
export function getTrainingClassSignupInfoList(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/cultivateActivityInfo/gl/v1.0.0/page`,
        method: 'post',
        data
    })
}

/**
 * 
 * @param{上线}id
 * @returns
 */
export function getTrainingClassSignupInfoOnline(id) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/cultivateActivityInfo/gl/v1.0.0/upOnline`,
        method: 'post',
        data: {
            id: id
        }
    })
}

/**
 * 
 * @param{下线}id
 * @returns
 */
export function getTrainingClassSignupInfoOffline(id) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/cultivateActivityInfo/gl/v1.0.0/downOnline`,
        method: 'post',
        data: {
            id: id
        }
    })
}


/**
 * 
 * @param{删除活动}id
 * @requires
 * 
 */
export function deleteTrainingClassSignupInfo(id) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/cultivateActivityInfo/gl/v1.0.0/delete`,
        method: 'post',
        data: {
            id: id
        }
    })
}

/**
 * 
 * @param {活动详情}data
 * @returns
 */
export function auditTrainingClassSignupInfo(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/cultivateActivityInfo/gl/v1.0.0/detail`,
        method: 'post',
        data
    })
}

/**
 * 
 * @param {报名人员列表 }data
 * @returns
 */
export function getTrainingClassSignupInfoPersonList(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/cultivateActivitySignInfo/gl/v1.0.0/page`,
        method: 'post',
        data
    })
}

/**
 * 
 * @param {审核报名信息}data
 * @returns
 */
export function updateTrainingClassSignupInfoPerson(data) {
    return request({
        url: `/${systemConfig.cultivatePrefix}/cultivateActivitySignInfo/gl/v1.0.0/audit`,
        method: 'post',
        data
    })
}